<div class="pdf-reader-container" [ngClass]="{'fullscreen': isFullscreen}">

    <div class="pdf-content" [ngClass]="{'loading':isLoading}" (scroll)="onScroll($event)">
        <pdf-viewer class="pdf-viewer" [src]="src" [fit-to-page]="true" (on-progress)="onProgress($event)"
            [(page)]="page" [original-size]="false" [autoresize]="true">
        </pdf-viewer>
    </div>
    <div *ngIf="hasController" class="pdf-controller">
        <button (click)="onDownload()" mat-icon-button aria-label="Download" [ngClass]="{'loading':isWaitingDownload}">
            <mat-icon>file_download</mat-icon>
        </button>
        <button (click)="onPrint()" mat-icon-button aria-label="Print" [ngClass]="{'loading':isWaitingPrint}">
            <mat-icon>local_printshop</mat-icon>
        </button>
        <button *ngIf="hasFullscreen" (click)="onFullscreenClick()" mat-icon-button aria-label="Fullscreen">
            <mat-icon>{{isFullscreen?'fullscreen_exit':'fullscreen'}}</mat-icon>
        </button>
    </div>
</div>